<template>
  <div>
    <van-collapse v-model="collapse1">
      <van-collapse-item :name="index" v-for="(s2, index) in itemss.S2" :key="s2.lv">
        <template slot="title">
          <span class="title">
            {{ getLvDscp(s2.lv) }}
          </span>
          <span
            :class="{
              red: getS2SelectedCount(s2.items) != s2.count,
              tip: getS2SelectedCount(s2.items) == s2.count,
            }"
            v-if="s2.lock"
          >
            (必需選擇{{ s2.count }}項)</span
          >
          <span v-else>
            <span
              :class="{
                red: getS2SelectedCount(s2.items) > s2.count,
                tip: getS2SelectedCount(s2.items) <= s2.count,
              }"
              v-if="Number(s2.count) > 0"
              >(最多選擇{{ s2.count }}項)</span
            >
            <span v-else>(請選擇)</span>
          </span>
        </template>
        <div v-for="it in s2.items" :key="it.ItemName">
          <div style="font-size: 1rem" v-if="it.ItemType.substr(0, 1) == 'Q'">
            <span v-if="it.value > 0">
              <el-button
                style="font-size: 1.5rem"
                type="text"
                icon="el-icon-remove-outline"
                circle
                @click="it.value--"
              >
              </el-button>
              <span style="font-size: 1.5rem">{{ it.value }}</span>
            </span>
            <el-button
              style="font-size: 1.5rem"
              type="text"
              icon="el-icon-circle-plus-outline"
              circle
              @click="it.value++"
              :disabled="isStopSale(it)"
            >
            </el-button>
            {{ it.ItemName }}
            <span style="color: orangered" v-if="!isStopSale(it)"> +${{ it.Price }}</span>
            <span style="margin-left: 0.5rem" v-else>
              <van-tag type="primary" color="#666" round size="large">
                已售完
              </van-tag></span
            >
          </div>
          <div v-else>
            <van-checkbox
              v-model="it.value"
              :disabled="isStopSale(it)"
              shape="square"
              @change="onChange(it)"
            >
              {{ it.ItemName }}
              <span style="color: orangered" v-if="!isStopSale(it)">
                +${{ it.Price }}</span
              >
              <span style="margin-left: 0.5rem" v-else>
                <van-tag type="primary" color="#666" round size="large">
                  已售完
                </van-tag></span
              >
            </van-checkbox>
            <div style="padding-left: 1.8rem; font-size: 1rem">
              <!-- {{ it.Notes }} -->
              <span v-for="nt in it.Notes" :key="nt.ItemNote">
                <van-tag plain type="primary" size="large" v-if="nt.value">{{
                  nt.ItemNote
                }}</van-tag>
              </span>
            </div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>

    <!-- frmNote -->
    <van-popup
      v-model="frmS2Note.visible"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-nav-bar :title="frmS2Note.title" placeholder />
      <div style="padding: 1rem">
        <div v-for="(inote, index) in frmS2Note.Notes" :key="index">
          <span v-if="index < 8">
            <van-checkbox v-model="inote.value" shape="square">
              {{ inote.ItemNote }}
            </van-checkbox>
          </span>
        </div>
      </div>
      <van-tabbar placeholder>
        <van-button type="info" size="large" @click="closeS2Note()">確認</van-button>
      </van-tabbar>
    </van-popup>
  </div>
</template>
<style scoped>
.van-checkbox {
  font-size: 1rem;
  height: 3rem;
}
.van-radio {
  font-size: 1rem;
  height: 3rem;
}
.red {
  color: red;
}
.tip {
  color: #555;
}
.title {
  color: #666;
  font-size: 1rem;
}

.van-tag {
  margin: 0 0 0 0.2rem;
}
</style>
<script>
export default {
  name: "ItemSS",
  props: {
    itemss: Object,
    params: Object,
  },
  data() {
    return {
      collapse1: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      frmS2Note: { visible: false, title: "口味備註", Notes: [] },
    };
  },
  methods: {
    getS2SelectedCount(items) {
      let count = 0;
      for (let i = 0; i < items.length; i++) {
        if (Number(items[i].value) > 0) {
          count += Number(items[i].value);
        }
      }
      return count;
    },
    getLvDscp(name) {
      if (name == undefined) {
        name = "";
      }
      var n = name.indexOf("_");
      var str = "";
      if (n > 0) {
        str = name.substr(n + 1);
      }
      return str;
    },
    isStopSale: function (obj) {
      if (obj.length == 0 || obj == undefined) {
        return true;
      }
      var kptype = obj.KPtype;
      if (kptype.substr(0, 1) == "-") {
        return true;
      }

      return false;
    },
    onChange: function (obj) {
      if (obj.value) {
        if (obj.Notes.length > 0) {
          this.showS2Note(obj);
        }
      } else {
        for (let i = 0; i < obj.Notes.length; i++) {
          obj.Notes[i].value = false;
        }
      }
      return;
    },
    showS2Note: function (obj) {
      var app = this;
      // alert(JSON.stringify(obj));
      app.frmS2Note.title = obj.ItemName + " 口味選擇";
      app.frmS2Note.Notes = obj.Notes;
      app.frmS2Note.visible = true;
    },
    closeS2Note: function () {
      var app = this;
      app.frmS2Note.visible = false;
    },
  },
};
</script>
